import isEmail from 'app/forms/validations/isEmail';

export const SETTINGS_EMAILS_FORM_NAME = 'settings-emails';

export const FIELDS = {
	summaryNotificationsEmail: 'summaryNotificationsEmail',
	tasksAndInformationByEmailEmail: 'tasksAndInformationByEmailEmail',
	taskCreationFailEmail: 'taskCreationFailEmail',
};

export default () => ({
	[FIELDS.summaryNotificationsEmail]: {
		deepPath: [FIELDS.summaryNotificationsEmail],
		validations: [isEmail()],
	},
	[FIELDS.tasksAndInformationByEmailEmail]: {
		deepPath: [FIELDS.tasksAndInformationByEmailEmail],
		validations: [isEmail()],
	},
	[FIELDS.taskCreationFailEmail]: {
		deepPath: [FIELDS.taskCreationFailEmail],
		validations: [isEmail()],
	},
});
